function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.5 50.894H21c-8.25 0-15-5.726-15-13.94 0-8.516 6.5-13.194 14-13.941C19.5 15.66 27.375 8 36 8c10.5 0 21 7.66 19.5 19.915 5.375.279 10.5 4.58 10.5 12.025 0 7.538-5.625 10.954-12.5 10.954h-7",
  stroke: "#FED602",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 33.532l9-9.192 9 9.192M36 24.34V56",
  stroke: "#FED602",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconSubmitSuccessYellow = function SvgIconSubmitSuccessYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 64",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA3MiA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjUgNTAuODkzNkgyMUMxMi43NSA1MC44OTM2IDYgNDUuMTY4MSA2IDM2Ljk1MzJDNiAyOC40MzgzIDEyLjUgMjMuNzU5NiAyMCAyMy4wMTI4QzE5LjUgMTUuNjU5NiAyNy4zNzUgOCAzNiA4QzQ2LjUgOCA1NyAxNS42NTk2IDU1LjUgMjcuOTE0OUM2MC44NzUgMjguMTkzNyA2NiAzMi40OTQ3IDY2IDM5Ljk0MDRDNjYgNDcuNDc4MiA2MC4zNzUgNTAuODkzNiA1My41IDUwLjg5MzZINDYuNSIgc3Ryb2tlPSIjRkVENjAyIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcgMzMuNTMxOEwzNiAyNC4zNDAzTDQ1IDMzLjUzMTgiIHN0cm9rZT0iI0ZFRDYwMiIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM2IDI0LjM0MDNWNTUuOTk5OSIgc3Ryb2tlPSIjRkVENjAyIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIconSubmitSuccessYellow as ReactComponent };